import type { ParseResult } from "papaparse"
import type { ModelFacade } from "@/utils/useEngineModel/ModelFacade"
import { MessageKind } from "@kaleidoscope-solutions/engine-wasm"
import { parse } from "papaparse"
import { defineStore } from "pinia"
import { nextTick } from "vue"

import messageHandler, { UIMessageKind } from "@/logic/message-handler"
import { DUMMY_UUID } from "@/utils"

interface State {
  model?: ModelFacade
  invalid: boolean
}

export const useDataHealthStore = defineStore("dataHealth", {
  state: (): State => ({
    model: undefined,
    invalid: false,
  }),

  actions: {
    async initialise(model: ModelFacade) {
      this.model = model
      this.setupListeners()
      await this.checkDataValidity()
    },
    setupListeners() {
      // Check if quantity sold is empty after an import is complete to update
      // the dashboard.
      messageHandler.on(MessageKind.ModelLoaded, this.checkDataValidity)
      messageHandler.on(UIMessageKind.DataImported, this.checkDataValidity)
      messageHandler.on(UIMessageKind.CellValueSet, this.checkDataValidity)
    },
    async checkDataValidity() {
      await nextTick()

      this.invalid = false

      const chart = await this.modelApi.chart(DUMMY_UUID, "'Data health'")

      const csvParse: ParseResult<{ "Chart Data": number }> = parse(chart.data, {
        skipEmptyLines: true,
        header: true
      })

      this.invalid = Number(csvParse.data[0]?.["Chart Data"] ?? 0) > 0
    }
  },
  getters: {
    modelApi(state) {
      if (state.model === undefined) {
        throw new Error("Model not initialised")
      }
      return state.model?.api
    },
  }
})
